// removed by extract-text-webpack-plugin
module.exports = {"Popup__Override":"_3taI8KndEWgmmdvl6mf4UJ","CancelSubscriptionDialog__options":"_2oufNimu_UrqXbEXsk8G5E","CancelSubscriptionDialog__note":"_3zLGzrrNoQThR_EnodnirJ","CancelSubscriptionDialog__message":"_1GoSo6y_YFqAmpNjtBXZPx","CancelSubscriptionDialog__buttons":"_3YIqpluC9PgQumML2qBpJy","CancelSubscriptionDialog__loading-indicator":"_3Uwp5of5QFpCh1wt5-H2j3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelSubscriptionDialog/CancelSubscriptionDialog.scss
// module id = 2429
// module chunks = 0